var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "send_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.734 3.258a.91.91 0 0 1 .215.943l-6.364 18.182a.909.909 0 0 1-1.689.069l-3.494-7.862-7.862-3.495a.91.91 0 0 1 .069-1.688L20.79 3.043a.909.909 0 0 1 .943.215zm-9.559 10.844 2.452 5.516 4.29-12.257-6.742 6.741zm5.456-8.027-12.257 4.29 5.516 2.452 6.741-6.742z",
    fill: "currentColor"
  })));
};

export { SvgSend as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjczNCAzLjI1OGEuOTEuOTEgMCAwMS4yMTUuOTQzbC02LjM2NCAxOC4xODJhLjkwOS45MDkgMCAwMS0xLjY4OS4wNjlsLTMuNDk0LTcuODYyLTcuODYyLTMuNDk1YS45MS45MSAwIDAxLjA2OS0xLjY4OEwyMC43OSAzLjA0M2EuOTA5LjkwOSAwIDAxLjk0My4yMTV6bS05LjU1OSAxMC44NDRsMi40NTIgNS41MTYgNC4yOS0xMi4yNTctNi43NDIgNi43NDF6bTUuNDU2LTguMDI3bC0xMi4yNTcgNC4yOSA1LjUxNiAyLjQ1MiA2Ljc0MS02Ljc0MnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";